import { Tooltip, TooltipContent, TooltipTrigger } from "@/shared/components/ui/tooltip";
import { HelpCircle } from "lucide-react";
import { useHelp } from "@/shared/hooks/useHelp";

interface HelpTooltipProps {
  text: string;
  className?: string;
}

const HelpTooltip = ({ text, className = "" }: HelpTooltipProps) => {
  const { helpEnabled } = useHelp();
  
  if (!helpEnabled) return null;

  return (
    <Tooltip delayDuration={200}>
      <TooltipTrigger asChild>
        <span
          className="inline-flex cursor-help ml-1 align-middle"
          aria-label="Ajuda"
          onClick={(e) => e.stopPropagation()}
          onPointerDown={(e) => e.stopPropagation()}
        >
          <HelpCircle className={`h-4 w-4 text-muted-foreground/70 hover:text-[#791614] transition-colors ${className}`} />
        </span>
      </TooltipTrigger>
      <TooltipContent
        side="top"
        align="center"
        sideOffset={8}
        collisionPadding={20}
        avoidCollisions={true}
        className="z-[100] max-w-[min(420px,90vw)] min-w-[220px] text-sm leading-relaxed px-4 py-3.5 overflow-visible rounded-lg bg-[#2D2824] text-[#f9f6f0] border border-[#d7b369]/50 shadow-2xl"
      >
        <span className="block whitespace-pre-wrap">{text}</span>
      </TooltipContent>
    </Tooltip>
  );
};

export default HelpTooltip;
